<template>
    <Card :title="$t('labels.main_information')">
        <div class="card-body">
            <div class="row">
                <div class="col-lg-3">
                    <FormGroup :label="$t('labels.name')" required>
                        <Input v-model="orderSource.name" />
                    </FormGroup>
                </div>
                <div class="col-lg-3">
                    <FormGroup :label="$t('labels.image')">
                        <ImageInputGroup v-model:image="orderSource.image_file" type="order-source" />
                    </FormGroup>
                </div>
                <div class="col-lg-2">
                    <FormGroup :label="$t('labels.color')">
                        <Input v-model="orderSource.color" type="color" />
                    </FormGroup>
                </div>
                <div class="col-lg-2">
                    <FormGroup :label="$t('labels.integration')" required>
                        <Input :model-value="orderSource.integration?.name" disabled/>
                    </FormGroup>
                </div>
                <div class="col-lg-2">
                    <FormGroup :label="$t('labels.price_template')">
                        <AppAutoComplete
                            @update:model-value="orderSource.price_template = $event"
                            :url="priceTemplatesUrl"
                            :model-value="orderSource.price_template?.uuid"
                            :selected-value="orderSource.price_template?.name"
                            :query-params="{ show_in_order: 1 }"
                        />
                    </FormGroup>
                </div>
            </div>
        </div>
        <div class="card-footer d-flex justify-content-end">
            <Button color="light" class="mr-2" @click="remove">
                <i class="icon-trash mr-2"></i>
                {{ $t('buttons.delete') }}
            </Button>
            <Button color="indigo" @click="update">
                <i class="icon-floppy-disk mr-2"></i>
                {{ $t('buttons.edit') }}
            </Button>
        </div>
    </Card>
</template>
<script>
import Card from "../../../../../components/new/CardComponent.vue";
import FormGroup from "../../../../../components/new/form/group/FormGroup.vue";
import Input from "../../../../../components/new/form/Input.vue";
import Button from "../../../../../components/new/button/AppButton.vue";
import ImageInputGroup from "../../../../components/input/ImageInputGroup.vue";
import { httpClient } from "../../../../../services/HttpClient";
import MessageNotificator from "../../../../../services/MessageNotificator";
import AppAutoComplete from "../../../../../components/new/form/autocomplete/AppAutoComplete.vue";

export default {
    name: 'MainInformationCard',
    components: {
        Card, FormGroup, Input, Button, ImageInputGroup, AppAutoComplete
    },
    emits: ['update:orderSource'],
    props: {
        orderSource: {
            type: Object,
            required: true
        }
    },
    computed: {
        priceTemplatesUrl() {
            return `/projects/${this.$route.params.projectUuid}/pim/price-templates`;
        },
    },
    methods: {
        update() {
            let requestData = {
                name: this.orderSource.name,
                image_file_uuid: this.orderSource.image_file?.uuid,
                color: this.orderSource.color
            };

            if (this.orderSource.price_template) {
                requestData.price_template_uuid = this.orderSource.price_template.uuid;
            }

            httpClient.put(`/projects/${this.$route.params.projectUuid}/crm/sources/${this.$route.params.orderSourceUuid}`, requestData).then((response) => {
                new MessageNotificator().success(this.$t('alerts.success'));
                this.$emit('update:orderSource', response.data.data);
            });
        },
        remove() {
            new MessageNotificator().confirm(this.$t('alerts.confirmDeleteOrderSource'), () => {
                httpClient.delete(`/projects/${this.$route.params.projectUuid}/crm/sources/${this.$route.params.orderSourceUuid}`).then(() => {
                    this.$router.push({name: 'OrderSourceIndexPage'});
                });
            });
        }
    }
}
</script>